import { useEffect, useState } from 'react';
import { useExperience } from '../../context/ExperienceContext';

interface MangaSFXProps {
  text: string;
  variant?: 'stamp' | 'action' | 'inline';
  className?: string;
  animate?: boolean;
}

export function MangaSFX({
  text,
  variant = 'stamp',
  className = '',
  animate = false,
}: MangaSFXProps) {
  const { isManga } = useExperience();
  const [visible, setVisible] = useState(!animate);

  useEffect(() => {
    if (animate) {
      const t = setTimeout(() => setVisible(true), 50);
      return () => clearTimeout(t);
    }
  }, [animate]);

  if (!isManga) return null;

  const base: React.CSSProperties = {
    fontFamily: "'Bangers', cursive",
    letterSpacing: '0.06em',
    lineHeight: 1,
    display: 'inline-block',
    transition: animate ? 'transform 0.25s cubic-bezier(0.34,1.56,0.64,1), opacity 0.2s' : undefined,
    opacity: visible ? 1 : 0,
    transform: visible
      ? variant === 'stamp' ? 'scale(1) rotate(-12deg)' : variant === 'action' ? 'scale(1) rotate(5deg)' : 'scale(1)'
      : 'scale(0.4) rotate(-20deg)',
  };

  if (variant === 'stamp') {
    return (
      <span
        className={`manga-sfx ${className}`}
        style={{
          ...base,
          background: '#E8192C',
          color: '#fff',
          padding: '2px 7px',
          fontSize: '13px',
          fontWeight: 400,
          boxShadow: '2px 2px 0 #000',
        }}
      >
        {text}
      </span>
    );
  }

  if (variant === 'action') {
    return (
      <span
        className={`manga-sfx ${className}`}
        style={{
          ...base,
          background: '#0a0a0a',
          color: '#fff',
          padding: '2px 7px',
          fontSize: '13px',
          fontWeight: 400,
          boxShadow: '2px 2px 0 rgba(0,0,0,0.3)',
        }}
      >
        {text}
      </span>
    );
  }

  return (
    <span
      className={`manga-sfx ${className}`}
      style={{
        ...base,
        color: '#E8192C',
        fontSize: '48px',
        fontWeight: 400,
        textShadow: '3px 3px 0 #0a0a0a',
      }}
    >
      {text}
    </span>
  );
}
